module.exports = __webpack_public_path__ + "static/media/50--wedding.cca3cd29.jpg";